import React, { Suspense, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useThree } from '@react-three/fiber'
import { Scroll, ScrollControls } from "@react-three/drei"
import Placeholder from './Placeholder.jsx'
import ReleaseItem3D from './ReleaseItem3D.jsx'
import Minimap from './Minimap.jsx'

export default function HomeScene({ releases, w = 275, h = 275, gap = 50 }) {
    const isMobile = useMediaQuery({ maxWidth: 850 }) // Define max-width for mobile devices
    if (isMobile) {
        gap = 75
    }
    const { width } = useThree((state) => state.viewport)
    const xW = w + gap
    const totalLength = releases?.length
    const [scale, setScale] = useState([w, h, 1])

    return (
        <>
            <directionalLight castShadow position={[0, 0, 1]} />
            <ambientLight intensity={0.5} />
            <ScrollControls
                pages={(width - xW + totalLength * xW) / width}
                horizontal={!isMobile} // Change the horizontal prop based on the device width
                damping={0.1}
            >
                <Scroll>
                    <Suspense fallback={<Placeholder position-y={1} scale={[20, 20, 20]} />}>
                        <group>
                            {
                                releases?.map((release, index) => {
                                    return (
                                        <ReleaseItem3D
                                            key={index}
                                            index={index}
                                            position={[
                                                index * xW,
                                                0, 0
                                            ]}
                                            scale={scale}
                                            setScale={setScale}
                                            release={release}
                                            totalLength={totalLength}
                                        />
                                    )
                                })
                            }
                        </group>
                    </Suspense>
                </Scroll>
                <Minimap items={releases} />
            </ScrollControls>
        </>
    )
}